import axios from 'axios'
import { getActingAccountId } from './actingAccount'

// Prod hosts the SPA on stayplay.integolf.com but the API on
// stayplayapi.integolf.com — the SPA host does NOT proxy /api/* through.
// VITE_API_ORIGIN is set at build time (e.g. https://stayplayapi.integolf.com)
// so axios calls go cross-origin to the right host. Locally it falls back to
// window.location.origin, where the Vite dev server proxies /api/* through.
const apiOrigin = import.meta.env.VITE_API_ORIGIN || window.location.origin


/**
 * Axios instance for PlayStay-API (portal-specific endpoints).
 * Vite proxies /api/play-stay-portal/* to http://localhost:3011 in dev;
 * prod uses the apiOrigin override to reach stayplayapi.integolf.com.
 */
export const portalApi = axios.create({
  baseURL: `${apiOrigin}/api/play-stay-portal`,
  headers: { 'Content-Type': 'application/json' },
})

/**
 * Axios instance for Tournament-API (shared infrastructure: provider abstraction,
 * existing Stay & Play package CRUD, etc.)
 * Vite proxies /api/* (except portal paths) to http://localhost:3001 in dev;
 * prod uses the apiOrigin override.
 */
export const tournamentApi = axios.create({
  baseURL: `${apiOrigin}/api`,
  headers: { 'Content-Type': 'application/json' },
})

// Attach JWT to both instances if present in localStorage
function attachAuth(config) {
  const token = localStorage.getItem('portal_token') || localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // EPIC #92 P5 — when a parent is "acting as" one of its managed children,
  // scope portal requests to that child. The server verifies the parent
  // relationship before honouring this header.
  const acting = getActingAccountId()
  if (acting) {
    config.headers['X-Acting-Account-Id'] = String(acting)
  }
  return config
}

portalApi.interceptors.request.use(attachAuth)
tournamentApi.interceptors.request.use(attachAuth)

// Default export = portalApi (most common case)
export default portalApi
